export default __webpack_public_path__ + "static/media/logout.731f3809.svg";